var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.735 15.9708C12.825 16.0608 12.925 16.1508 13.015 16.2408C15.465 18.7008 17.925 21.1508 20.375 23.6108C20.735 23.9708 20.715 24.4908 20.345 24.7908C20.065 25.0208 19.635 25.0108 19.375 24.7708C19.175 24.5908 18.985 24.3908 18.795 24.2008C16.725 22.1308 14.645 20.0508 12.575 17.9808C12.155 17.5608 11.735 17.1408 11.315 16.7108C10.895 16.2908 10.895 15.6508 11.315 15.2308C11.925 14.6208 12.535 14.0108 13.145 13.4008C14.585 11.9608 16.025 10.5108 17.475 9.07076C18.095 8.45076 18.715 7.83076 19.335 7.22076C19.555 7.00076 19.895 6.94076 20.175 7.06076C20.465 7.19076 20.655 7.47076 20.645 7.79076C20.645 8.00076 20.555 8.18076 20.405 8.32076C19.195 9.53076 17.985 10.7308 16.775 11.9408C16.325 12.3908 15.865 12.8408 15.415 13.3008C14.545 14.1708 13.675 15.0408 12.805 15.9108C12.785 15.9308 12.765 15.9508 12.735 15.9808V15.9708Z",
    fill: "#D3607D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow_Left.df5c1c2b61c27257549d0934eda20a58.svg";
export { ForwardRef as ReactComponent };